import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

export class RutValidator {

    /**
     * Formatea un RUT chileno al formato estándar con puntos y guión.
     * Acepta cualquier entrada y devuelve XX.XXX.XXX-D.
     * Puede usarse tanto en directivas como en componentes al pre-rellenar valores.
     */
    static format(value: string): string {
        if (!value) { return ''; }
        const clean = value.toString().replace(/[^0-9kK]/g, '').toUpperCase();
        if (clean.length < 2) { return clean; }

        const verifier = clean.slice(-1);
        const body = clean.slice(0, -1);

        let formatted = '';
        for (let i = 0; i < body.length; i++) {
            formatted += body[i];
            const remaining = body.length - i - 1;
            if (remaining > 0 && remaining % 3 === 0) { formatted += '.'; }
        }
        return `${formatted}-${verifier}`;
    }

    /**
     * Valida formato RUT chileno con o sin puntos y guión.
     * Acepta: 27.075.834-7 / 27075834-7 / 270758347
     */
    static verify(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const input: string = (control.value || '').toString().trim();
            if (!input) { return null; }

            // Limpiar puntos y guión
            const clean = input.replace(/\./g, '').replace(/-/g, '');
            if (clean.length < 2) { return { rut: { msg: 'RUT inválido' } }; }

            const verifier = clean.slice(-1).toLowerCase();
            const body = clean.slice(0, -1);

            // Solo dígitos en el cuerpo
            if (!/^\d+$/.test(body)) { return { rut: { msg: 'RUT inválido' } }; }
            if (!/^[\dk]$/.test(verifier)) { return { rut: { msg: 'RUT inválido' } }; }

            // Cálculo dígito verificador
            let M = 2, S = 0;
            for (let i = body.length - 1; i >= 0; i--) {
                S += parseInt(body[i], 10) * M;
                M = M < 7 ? M + 1 : 2;
            }

            const dvExpected = 11 - (S % 11);
            let dvStr: string;
            if (dvExpected === 10) { dvStr = 'k'; }
            else if (dvExpected === 11) { dvStr = '0'; }
            else { dvStr = dvExpected.toString(); }

            return dvStr === verifier ? null : { rut: { msg: 'RUT inválido' } };
        };
    }

    /** @deprecated Usar verify() en su lugar */
    static rutValidatorRegExp(): ValidatorFn {
        return RutValidator.verify();
    }
}
